import { useEffect, useState, useCallback } from "react";
import React from "react";
import "../../Components/Page/Page.css";
import { useUser } from "../../Context/UserContext";
import { useNavigate } from "react-router-dom";
import "../LandingPage/LandingPage.css";
import Footer from "../../Components/Footer/FooterSmall";
import Header2 from "../../Components/Header2/Header2";
import useAPI from "../../Hooks/useAPI";
import "./EspecDemo4.css";
import SecHeader from "../../Components/SecHeader/SecHeader";
import Button2 from "../../Components/Button2/Button2";
import * as Slider from "@radix-ui/react-slider";
import {
  faSort,
  faSortUp,
  faSortDown,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaTrash } from "react-icons/fa";

interface Engine {
  id: number;
  manufacturer: string;
  model: string;
  displacement_l: number;
  bore_mm: number;
  stroke_mm: number;
  compression_ratio: number;
  torque_lbft: number;
  power_output_hp: number;
  max_turbocharger_compression_psi: number;
  number_of_cylinders: number;
  cylinder_configuration: string;
  fuel_type: string;
  valvetrain: string;
  aspiration: string;
  fuel_system: string;
  redline_rpm: number;
  cooling_system: string;
  dry_weight_lb: number;
  ignition_type: string;
  maximum_rpm: number;
  stroke_type: string;
  maximum_power_output_hp: number;
  continuous_power_output_hp: number;
  dimensions: string;
  emissions_us_tier: string;
  emissions_eu_stage: string;
  engine_application: string;
  created_at: string;
  updated_at: string;
  category: string;
  data_quality_flag: boolean;
  bsfc_rated_g_kwh: number;
  bsfc_peak_torque_g_kwh: number;
  bsfc_source: string;
  brake_thermal_efficiency: number;
  compare_id: number;
  comp_display_row: number;
  comp_display_column: number;
}

interface EngineComparison {
  id: number;
  manufacturer?: string;
}

export default function EspecDemo4() {
  const [engines, setEngines] = useState<Engine[]>([]);
  const [compengines, setComparisonEngines] = useState<Engine[]>([]);
  const [selectedEngineIds, setSelectedEngineIds] = useState<number[]>([]);

  const [noData, setNoData] = useState(false);
  const [error, setError] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [gridview, setGridview] = useState<boolean>(false);
  const { user } = useUser();
  const navigate = useNavigate();
  const { getEngines, getEngineFilters, getEngineComp } = useAPI();
  const [showFilters, setShowFilters] = useState(true);

  const [selectedCategory, setSelectedCategory] = useState(() => {
    return localStorage.getItem("categoryFilter") || "";
  });
  const [selectedManufacturer, setSelectedManufacturer] = useState(() => {
    return localStorage.getItem("manufacturerFilter") || "";
  });
  const [selectedModel, setSelectedModel] = useState(() => {
    return localStorage.getItem("modelFilter") || "";
  });
  const [selectedEngineApplication, setSelectedEngineApplication] = useState(
    () => {
      return localStorage.getItem("engineApplicationFilter") || "";
    },
  );
  const [selectedNbrCylinders, setSelectedNbrCylinders] = useState(() => {
    return localStorage.getItem("nbrCylindersFilter") || "";
  });
  const [selectedCylinderConfig, setSelectedCylinderConfig] = useState(() => {
    return localStorage.getItem("cylinderConfigFilter") || "";
  });
  const [selectedFuelType, setSelectedFuelType] = useState(() => {
    return localStorage.getItem("fuelTypeFilter") || "";
  });

  const [selectedFuelSystem, setSelectedFuelSystem] = useState(() => {
    return localStorage.getItem("fuelSystemFilter") || "";
  });
  const [selectedCoolingSystem, setSelectedCoolingSystem] = useState(() => {
    return localStorage.getItem("coolingSystemFilter") || "";
  });
  const [selectedIgnitionType, setSelectedIgnitionType] = useState(() => {
    return localStorage.getItem("ignitionTypeFilter") || "";
  });
  const [selectedDisplacementMin, setSelectedDisplacementMin] = useState(() => {
    return localStorage.getItem("displacementMinFilter") || "";
  });
  const [selectedDisplacementMax, setSelectedDisplacementMax] = useState(() => {
    return localStorage.getItem("displacementMaxFilter") || "";
  });
  const [selectedCompressionRatioMin, setSelectedCompressionRatioMin] =
    useState(() => {
      return localStorage.getItem("compressionRatioMinFilter") || "";
    });
  const [selectedCompressionRatioMax, setSelectedCompressionRatioMax] =
    useState(() => {
      return localStorage.getItem("compressionRatioMaxFilter") || "";
    });
  const [selectedBoreMin, setSelectedBoreMin] = useState(() => {
    return localStorage.getItem("boreMinFilter") || "";
  });
  const [selectedBoreMax, setSelectedBoreMax] = useState(() => {
    return localStorage.getItem("boreMaxFilter") || "";
  });

  const [selectedStrokeMin, setSelectedStrokeMin] = useState(() => {
    return localStorage.getItem("strokeMinFilter") || "";
  });
  const [selectedStrokeMax, setSelectedStrokeMax] = useState(() => {
    return localStorage.getItem("strokeMaxFilter") || "";
  });

  const [selectedTorqueMin, setSelectedTorqueMin] = useState(() => {
    return localStorage.getItem("torqueMinFilter") || "";
  });
  const [selectedTorqueMax, setSelectedTorqueMax] = useState(() => {
    return localStorage.getItem("torqueMaxFilter") || "";
  });
  const [selectedPowerOutputMin, setSelectedPowerOutputMin] = useState(() => {
    return localStorage.getItem("powerOutputMinFilter") || "";
  });
  const [selectedPowerOutputMax, setSelectedPowerOutputMax] = useState(() => {
    return localStorage.getItem("powerOutputMaxFilter") || "";
  });

  const [rangePowerOutput, setRangePowerOutput] = useState([0, 1000]);
  const [rangeTorque, setRangeTorque] = useState([0, 600]);

  type EngineField = {
    label: string;
    key: keyof Engine;
  };

  const fields: EngineField[] = [
    { label: "Manufacturer", key: "manufacturer" },
    { label: "Model", key: "model" },
    { label: "Application", key: "engine_application" },
    { label: "Max Power Output (hp)", key: "maximum_power_output_hp" },
    { label: "Max Torque (lb-ft)", key: "torque_lbft" },
    { label: "Ignition Type", key: "ignition_type" },
    { label: "Displacement (L)", key: "displacement_l" },
    { label: "Dry Weight (lb)", key: "dry_weight_lb" },
    { label: "Cylinder Layout", key: "cylinder_configuration" },
    { label: "Compression Ratio", key: "compression_ratio" },
    { label: "Brake Thermal Efficiency", key: "brake_thermal_efficiency" },
    { label: "Remove", key: "id" },
  ];

  const [ddlFilterValues, setddlFilterValues] = useState({
    applications: [],
    categories: [],
    coolingsystems: [],
    cylinderconfigurations: [],
    fueltypes: [],
    fuelsystems: [],
    ignitiontypes: [],
    manufacturers: [],
  });

  const [sortConfig, setSortConfig] = useState<{
    key: keyof Engine | null;
    direction: "ascending" | "descending" | null;
  }>({
    key: null,
    direction: null,
  });

  const fetchEnginesComparison = useCallback(async () => {
    try {
      const response = await getEngines(JSON.stringify(null));

      if (response?.data) {
        setComparisonEngines(response.data);
      } else {
        throw new Error("Failed to fetch comparison engines");
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred");
    } finally {
      setIsLoading(false);
    }
  }, [getEngines]);

  //the field names in engineFilters below must match the fieldnames in the espec.engine_specs_main table.
  const fetchEngines = useCallback(async () => {
    try {
      setIsLoading(true);
      setError("");
      setSelectedPowerOutputMin(rangePowerOutput[0].toString());
      setSelectedPowerOutputMax(rangePowerOutput[1].toString());
      localStorage.setItem(
        "powerOutputMinFilter",
        rangePowerOutput[0].toString(),
      );
      localStorage.setItem(
        "powerOutputMaxFilter",
        rangePowerOutput[1].toString(),
      );
      setSelectedPowerOutputMin(rangeTorque[0].toString());
      setSelectedPowerOutputMax(rangeTorque[1].toString());
      localStorage.setItem("torqueMinFilter", rangeTorque[0].toString());
      localStorage.setItem("torqueMaxFilter", rangeTorque[1].toString());

      const engineFilters = {
        category: selectedCategory,
        manufacturer: selectedManufacturer,
        model: selectedModel,
        engine_application: selectedEngineApplication,
        number_of_cylinders: selectedNbrCylinders,
        cylinder_configuration: selectedCylinderConfig,
        fuel_type: selectedFuelType,
        fuel_system: selectedFuelSystem,
        cooling_system: selectedCoolingSystem,
        ignition_type: selectedIgnitionType,
        displacement_l: {
          min: selectedDisplacementMin,
          max: selectedDisplacementMax,
        },
        compression_ratio: {
          min: selectedCompressionRatioMin,
          max: selectedCompressionRatioMax,
        },
        bore_mm: {
          min: selectedBoreMin,
          max: selectedBoreMax,
        },
        stroke_mm: {
          min: selectedStrokeMin,
          max: selectedStrokeMax,
        },
        torque_lbft: {
          min: rangeTorque[0].toString(),
          max: rangeTorque[1].toString(),
        },
        power_output_hp: {
          min: rangePowerOutput[0].toString(),
          max: rangePowerOutput[1].toString(),
        },
      };

      const response = await getEngines(JSON.stringify(engineFilters));

      if (response?.data) {
        // setEngines(response.data);
        setNoData(false);

        setEngines(response.data);

        if (response?.data.length === 0) {
          setNoData(true);
        }
      } else {
        throw new Error("Failed to fetch engines");
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred");
    } finally {
      setIsLoading(false);
    }
  }, [
    getEngines,
    selectedCategory,
    selectedManufacturer,
    selectedModel,
    selectedEngineApplication,
    selectedNbrCylinders,
    selectedCylinderConfig,
    selectedFuelType,
    selectedFuelSystem,
    selectedCoolingSystem,
    selectedIgnitionType,
    selectedDisplacementMin,
    selectedDisplacementMax,
    selectedCompressionRatioMin,
    selectedCompressionRatioMax,
    selectedBoreMin,
    selectedBoreMax,
    selectedStrokeMin,
    selectedStrokeMax,
    selectedTorqueMin,
    selectedTorqueMax,
    selectedPowerOutputMin,
    selectedPowerOutputMax,
    rangePowerOutput,
    rangeTorque,
  ]);

  const fetchEngineFilters = useCallback(async () => {
    try {
      const response = await getEngineFilters();
      const filters = response.data[0].data;
      setddlFilterValues(filters);
    } catch (error) {
      setError("Failed to fetch engine filters");
    }
  }, []);

  const fetchEngineComp = useCallback(async (engineid: number) => {
    try {
      const response = await getEngineComp(engineid);
      const autocomps = response.data;

      setSelectedEngineIds((prev) => {
        const ids: number[] = autocomps.map(
          (e: { enginecompid: number }) => e.enginecompid,
        );
        const newIds = ids.filter((id) => !prev.includes(id));
        return [...prev, ...newIds];
      });
    } catch (error) {
      setError("Failed to fetch engine comparisons");
    }
  }, []);

  useEffect(() => {
    // Check if user is logged in
    if (!user) {
      navigate("/login");
      return;
    }

    // if (!ddlFilterValues.) {
    fetchEngineFilters();
    // }

    fetchEngines();
    fetchEnginesComparison();
  }, [user, navigate, fetchEngines, fetchEnginesComparison]);

  useEffect(() => {
    localStorage.setItem("categoryFilter", selectedCategory);
    localStorage.setItem("manufacturerFilter", selectedManufacturer);
    localStorage.setItem("engineApplicationFilter", selectedEngineApplication);
    localStorage.setItem("nbrCylindersFilter", selectedNbrCylinders);
    localStorage.setItem("fuelTypeFilter", selectedFuelType);
    localStorage.setItem("coolingSystemFilter", selectedCoolingSystem);
    localStorage.setItem("ignitionTypeFilter", selectedIgnitionType);
    localStorage.setItem("displacementMinFilter", selectedDisplacementMin);
    localStorage.setItem("displacementMaxFilter", selectedDisplacementMax);
    localStorage.setItem(
      "compressionRatioMinFilter",
      selectedCompressionRatioMin,
    );
    localStorage.setItem(
      "compressionRatioMaxFilter",
      selectedCompressionRatioMax,
    );
    localStorage.setItem("boreMinFilter", selectedBoreMin);
    localStorage.setItem("boreMaxFilter", selectedBoreMax);
    localStorage.setItem("strokeMinFilter", selectedStrokeMin);
    localStorage.setItem("strokeMaxFilter", selectedStrokeMax);
    localStorage.setItem("torqueMinFilter", selectedTorqueMin);
    localStorage.setItem("torqueMaxFilter", selectedTorqueMax);
    localStorage.setItem("powerOutputMinFilter", selectedPowerOutputMin);
    localStorage.setItem("powerOutputMaxFilter", selectedPowerOutputMax);
  }, [rangePowerOutput, rangeTorque]);

  const handleClear = () => {
    setSelectedCategory(""); // clears input
    localStorage.setItem("categoryFilter", ""); // ensures blank is saved
    setSelectedManufacturer(""); // clears input
    localStorage.setItem("manufacturerFilter", ""); // ensures blank is saved
    selectedEngineApplication && setSelectedEngineApplication("");
    localStorage.setItem("engineApplicationFilter", "");
    setSelectedCylinderConfig(""); //clears input
    selectedNbrCylinders && setSelectedNbrCylinders("");
    localStorage.setItem("nbrCylindersFilter", "");
    selectedFuelType && setSelectedFuelType("");
    localStorage.setItem("fuelTypeFilter", "");
    selectedFuelSystem && setSelectedFuelSystem("");
    localStorage.setItem("fuelSystemFilter", "");
    selectedCoolingSystem && setSelectedCoolingSystem("");
    localStorage.setItem("coolingSystemFilter", "");
    selectedIgnitionType && setSelectedIgnitionType("");
    localStorage.setItem("ignitionTypeFilter", "");
    selectedDisplacementMin && setSelectedDisplacementMin("");
    localStorage.setItem("displacementMinFilter", "");
    selectedDisplacementMax && setSelectedDisplacementMax("");
    localStorage.setItem("displacementMaxFilter", "");
    selectedCompressionRatioMin && setSelectedCompressionRatioMin("");
    localStorage.setItem("compressionRatioMinFilter", "");
    selectedCompressionRatioMax && setSelectedCompressionRatioMax("");
    localStorage.setItem("compressionRatioMaxFilter", "");
    selectedBoreMin && setSelectedBoreMin("");
    localStorage.setItem("boreMinFilter", "");
    selectedBoreMax && setSelectedBoreMax("");
    localStorage.setItem("boreMaxFilter", "");
    selectedStrokeMin && setSelectedStrokeMin("");
    localStorage.setItem("strokeMinFilter", "");
    selectedStrokeMax && setSelectedStrokeMax("");
    localStorage.setItem("strokeMaxFilter", "");
    selectedTorqueMin && setSelectedTorqueMin("");
    localStorage.setItem("torqueMinFilter", "");
    selectedTorqueMax && setSelectedTorqueMax("");
    localStorage.setItem("torqueMaxFilter", "");
    selectedPowerOutputMin && setSelectedPowerOutputMin("0");
    localStorage.setItem("powerOutputMinFilter", "0");
    selectedPowerOutputMax && setSelectedPowerOutputMax("1000");
    localStorage.setItem("powerOutputMaxFilter", "1000");

    setRangePowerOutput([0, 1000]);
    setRangeTorque([0, 600]);
  };

  const getSortIcon = (columnKey: keyof Engine) => {
    if (sortConfig.key !== columnKey) {
      return <FontAwesomeIcon icon={faSort} />;
    }
    return sortConfig.direction === "ascending" ? (
      <FontAwesomeIcon icon={faSortUp} />
    ) : (
      <FontAwesomeIcon icon={faSortDown} />
    );
  };
  const handleSort = (key: keyof Engine) => {
    let direction: "ascending" | "descending" | null = "ascending";

    if (sortConfig.key === key) {
      if (sortConfig.direction === "ascending") {
        direction = "descending";
      } else if (sortConfig.direction === "descending") {
        direction = null;
      }
    }

    setSortConfig({ key, direction });
  };

  const getSortedEngines = () => {
    let filteredEngines = engines;

    if (!sortConfig.key || !sortConfig.direction) {
      return filteredEngines;
    }

    return [...filteredEngines].sort((a, b) => {
      const aValue = a[sortConfig.key!];
      const bValue = b[sortConfig.key!];

      // Handle different data types
      let aStr: string;
      let bStr: string;

      if (Array.isArray(aValue)) {
        aStr = aValue.join(", ");
        bStr = Array.isArray(bValue) ? bValue.join(", ") : "";
      } else if (typeof aValue === "boolean") {
        aStr = aValue ? "Yes" : "No";
        bStr = typeof bValue === "boolean" ? (bValue ? "Yes" : "No") : "";
      } else if (typeof aValue === "number") {
        aStr = aValue.toString();
        bStr = typeof bValue === "number" ? bValue.toString() : "";
      } else {
        aStr = aValue ? aValue.toString().toLowerCase() : "";
        bStr = bValue ? bValue.toString().toLowerCase() : "";
      }

      if (aStr < bStr) {
        return sortConfig.direction === "ascending" ? -1 : 1;
      }
      if (aStr > bStr) {
        return sortConfig.direction === "ascending" ? 1 : -1;
      }
      return 0;
    });
  };

  type Option = {
    name: string;
  };

  type SelectOption = {
    label: string;
    value: string;
  };

  type DropdownProps = {
    options: Option[];
    value: string | number;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  };

  function Dropdown({ options, value, onChange }: DropdownProps) {
    return (
      <select value={value} onChange={onChange}>
        <option value="">All</option>
        {options.map((o) => (
          <option key={o.name} value={o.name}>
            {o.name}
          </option>
        ))}
      </select>
    );
  }

  function formatPercentage(value: number | string | null | undefined): string {
    if (value == null || isNaN(Number(value))) return "NA";
    return `${Math.round(Number(value))}%`;
  }

  const toggleEngine = (id: number) => {
    setSelectedEngineIds((prev) => {
      if (prev.includes(id)) {
        return prev.filter((x) => x !== id);
      }
      fetchEngineComp(id);
      return [...prev, id];
    });
  };

  const selectedEngines = selectedEngineIds
    .map((id) => compengines.find((e) => e.id === id))
    .filter(Boolean) as Engine[];

  const selectAllEngines = () => {
    const allIds = compengines.map((e) => e.id);
    setSelectedEngineIds(allIds);
  };

  const clearAllEngines = () => {
    setSelectedEngineIds([]);
  };

  return (
    <div className="generalPage">
      <Header2 />
      <div className="pageContainer">
        <div className="espec4-title-container">
          <div className="sectionContainer">
            <SecHeader title="ESPECTM Engine Comparison Tool" iSize={6} />
          </div>

          <div className="espec4-container">
            <div className="espec4-comparison-wrapper">
              <div className="espec4-comparison-section">
                <div className="espec4-engine-card engine-display-container">
                  <div className="engine-display-scroll">
                    <div
                      className="engine-display-grid"
                      style={{ ["--col-count" as any]: selectedEngines.length }}
                    >
                      {/* EMPTY top-left */}
                      <div></div>
                      {selectedEngines.length === 0 && (
                        <div className="engine-display-placeholder">
                          Select engines to compare
                        </div>
                      )}

                      {/* COLUMN HEADERS */}
                      {selectedEngines.map((selectedengine, i) => (
                        <div key={i}>
                          {/* Do not remove - it will break alignment */}
                        </div>
                      ))}

                      {/* ROWS (ALWAYS SHOW LABELS) */}
                      {fields.map((field, rowIndex) => (
                        <div key={rowIndex} style={{ display: "contents" }}>
                          {/* LABEL (always visible) */}
                          <div className="engine-display-label">
                            <div className="engine-display-label-inner">
                              {field.label}
                            </div>
                          </div>

                          {/* VALUES (only if selected engines exist) */}
                          {selectedEngines.length > 0 &&
                            selectedEngines.map((selectedengine, colIndex) => {
                              const manufacturer =
                                selectedengine.manufacturer?.toLowerCase() ||
                                "";
                              const fieldKey = field.key?.toLowerCase();

                              const isElf = manufacturer.includes("elf");

                              const isTitleField =
                                fieldKey === "manufacturer" ||
                                fieldKey === "model";

                              const value = selectedengine?.[field.key];

                              return (
                                <div
                                  key={colIndex}
                                  className={`engine-display-header
          ${isElf ? "engine-display-header-elf-tech" : ""}
          ${!isTitleField ? "engine-display-cell" : ""}
        `}
                                >
                                  {fieldKey === "brake_thermal_efficiency" ? (
                                    formatPercentage(
                                      selectedengine?.brake_thermal_efficiency,
                                    )
                                  ) : fieldKey === "manufacturer" ? (
                                    <>
                                      {value ?? "-"}
                                      {isElf && <sup>TM</sup>}
                                    </>
                                  ) : fieldKey === "id" ? (
                                    <>
                                      {" "}
                                      <Button2
                                        name="remove"
                                        text={
                                          <FaTrash
                                            size={12}
                                            title="Remove from comparison"
                                          />
                                        }
                                        type="button"
                                        classname="trashButton"
                                        onClick={() =>
                                          toggleEngine(selectedengine.id)
                                        }
                                      />
                                    </>
                                  ) : (
                                    (value ?? "-")
                                  )}
                                </div>
                              );
                            })}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="espec4-filter-wrapper">
              {/* MOBILE HEADER (always visible) */}
              <div className="espec4-filter-toggle-mobile">
                <button
                  className="show-hide-button"
                  onClick={() => setShowFilters((prev) => !prev)}
                >
                  <span>{showFilters ? "▼" : "▶"}</span>
                  {showFilters ? "Hide Filters" : "Show Filters"}
                </button>
              </div>

              {/* COLLAPSIBLE CONTENT */}
              <div className="espec4-filter-grid">
                {/* COLUMN 1 - Power */}
                <div className={showFilters ? "open" : "collapsed"}>
                  {showFilters && (
                    <>
                      {/* Power + Torque filters */}

                      <div className="espec4-filter-section">
                        <label className="espec4-filter-label">
                          Power Output
                        </label>
                        <div className="espec4-filter-group-min-max">
                          <div className="espec4-range-container">
                            <div className="espec4-selected-range">
                              <div style={{ marginBottom: "5px" }}>
                                Selected range: {rangePowerOutput[0]} hp -{" "}
                                {rangePowerOutput[1]} hp
                              </div>
                              <Slider.Root
                                value={rangePowerOutput}
                                onValueChange={setRangePowerOutput}
                                min={0}
                                max={1000}
                                step={100}
                                style={{
                                  position: "relative",
                                  display: "flex",
                                  alignItems: "center",
                                  width: "100%",
                                  height: 20,
                                }}
                              >
                                <Slider.Track
                                  style={{
                                    backgroundColor: "#e5e7eb",
                                    position: "relative",
                                    flexGrow: 1,
                                    height: 4,
                                    borderRadius: 2,
                                  }}
                                >
                                  <Slider.Range
                                    style={{
                                      position: "absolute",
                                      backgroundColor: "#0C929C",
                                      height: "100%",
                                      borderRadius: 9999,
                                    }}
                                  />
                                </Slider.Track>

                                <Slider.Thumb
                                  style={{
                                    display: "block",
                                    width: 20,
                                    height: 20,
                                    backgroundColor: "#0C929C",
                                    border: "2px solid #0C929C", // 👈 teal border
                                    borderRadius: "50%",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                    cursor: "pointer",
                                  }}
                                />
                                <Slider.Thumb
                                  style={{
                                    display: "block",
                                    width: 20,
                                    height: 20,
                                    backgroundColor: "#0C929C",
                                    border: "2px solid #0C929C",
                                    borderRadius: "50%",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                    cursor: "pointer",
                                  }}
                                />
                              </Slider.Root>

                              {/* Ticks */}
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  marginTop: 10,
                                }}
                              >
                                {Array.from({ length: 11 }).map((_, i) => (
                                  <span key={i} style={{ fontSize: 10 }}>
                                    {i * 100}
                                  </span>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="espec4-filter-section">
                        <label className="espec4-filter-label">
                          Max Torque (lb-ft)
                        </label>
                        <div className="espec4-filter-group-min-max">
                          <div className="espec4-range-container">
                            <div className="espec4-selected-range">
                              <div style={{ marginBottom: "5px" }}>
                                Selected range: {rangeTorque[0]} -{" "}
                                {rangeTorque[1]}
                              </div>
                              <Slider.Root
                                value={rangeTorque}
                                onValueChange={setRangeTorque}
                                min={0}
                                max={600}
                                step={100}
                                style={{
                                  position: "relative",
                                  display: "flex",
                                  alignItems: "center",
                                  width: "100%",
                                  height: 20,
                                }}
                              >
                                <Slider.Track
                                  style={{
                                    backgroundColor: "#e5e7eb",
                                    position: "relative",
                                    flexGrow: 1,
                                    height: 4,
                                    borderRadius: 2,
                                  }}
                                >
                                  <Slider.Range
                                    style={{
                                      position: "absolute",
                                      backgroundColor: "#0C929C",
                                      height: "100%",
                                      borderRadius: 9999,
                                    }}
                                  />
                                </Slider.Track>

                                <Slider.Thumb
                                  style={{
                                    display: "block",
                                    width: 20,
                                    height: 20,
                                    backgroundColor: "#0C929C",
                                    border: "2px solid #0C929C", // 👈 teal border
                                    borderRadius: "50%",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                    cursor: "pointer",
                                  }}
                                />
                                <Slider.Thumb
                                  style={{
                                    display: "block",
                                    width: 20,
                                    height: 20,
                                    backgroundColor: "#0C929C",
                                    border: "2px solid #0C929C",
                                    borderRadius: "50%",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                    cursor: "pointer",
                                  }}
                                />
                              </Slider.Root>

                              {/* Ticks */}
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  marginTop: 10,
                                }}
                              >
                                {Array.from({ length: 7 }).map((_, i) => (
                                  <span key={i} style={{ fontSize: 10 }}>
                                    {i * 100}
                                  </span>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* COLUMN 2 - Dropdown */}
                <div className={showFilters ? "open" : "collapsed"}>
                  {showFilters && (
                    <>
                      <div className="espec4-filter2-group">
                        <label className="espec4-filter-label">
                          Ignition Type
                        </label>
                        <select
                          value={selectedIgnitionType}
                          onChange={(e) =>
                            setSelectedIgnitionType(e.target.value)
                          }
                        >
                          <option value="">All</option>
                          <option value="Compression">Compression</option>
                          <option value="Spark">Spark</option>
                        </select>
                        {/* <select
                   <option value="">-- Select --</option>
                  
                  onChange={(e) => setSelectedEngineApplication(e.target.value)}
                /> */}
                      </div>
                      <div className="espec4-filter2-group">
                        <label className="espec4-filter-label">
                          Application Type
                        </label>
                        <select
                          value={selectedEngineApplication}
                          onChange={(e) =>
                            setSelectedEngineApplication(e.target.value)
                          }
                        >
                          <option value="">All</option>
                          <option value="Land">Land</option>
                          <option value="Marine">Marine</option>
                          <option value="Air">Air</option>
                        </select>
                        {/* <select
                   <option value="">-- Select --</option>
                  
                  onChange={(e) => setSelectedEngineApplication(e.target.value)}
                /> */}
                      </div>
                    </>
                  )}
                </div>

                {/* COLUMN 3 - More Filters Dropdown */}
                <div className={showFilters ? "open" : "collapsed"}>
                  {showFilters && (
                    <>
                      <div className="espec4-filter2-group">
                        <label className="espec4-filter-label">
                          Manufacturer
                        </label>
                        <Dropdown
                          options={ddlFilterValues.manufacturers}
                          value={selectedManufacturer}
                          onChange={(e) =>
                            setSelectedManufacturer(e.target.value)
                          }
                        />
                      </div>
                      <div className="espec4-filter2-group">
                        <label className="espec4-filter-label">
                          Cylinder Layout
                        </label>
                        <Dropdown
                          options={ddlFilterValues.cylinderconfigurations}
                          value={selectedCylinderConfig}
                          onChange={(e) =>
                            setSelectedCylinderConfig(e.target.value)
                          }
                        />
                      </div>
                    </>
                  )}
                </div>

                {/* COLUMN 4 - ALWAYS VISIBLE (THIS IS KEY) */}
                <div className="espec4-filter-column-4">
                  {/* TOP: show/hide */}
                  <div className="espec4-filter-toggle-desktop">
                    <button
                      className="show-hide-button"
                      onClick={() => setShowFilters((prev) => !prev)}
                    >
                      <span>{showFilters ? "▼" : "▶"}</span>
                      {showFilters ? "Hide Filters" : "Show Filters"}
                    </button>
                  </div>

                  {/* BOTTOM: actions */}
                  {showFilters && (
                    <>
                      <div className="espec4-filter-actions-mobile">
                        <div className="espec4-actions-grid">
                          {/* ROW 1 - FULL WIDTH */}
                          <div className="espec4-clear-all-row">
                            <Button2
                              name="submit"
                              text="Clear All Filters"
                              type="button"
                              classname="submit-btn"
                              onClick={handleClear}
                            />
                          </div>
                          {/* ROW 2 LEFT */}
                          <div className="espec4-grid-left">
                            <label className="grid-view-toggle">
                              <input
                                type="checkbox"
                                checked={gridview}
                                onChange={() => setGridview(!gridview)}
                                className="checkboxCtrl"
                              />
                              Grid View
                            </label>
                          </div>
                          {/* ROW 2 RIGHT */}
                          <div className="espec4-grid-right">
                            <div className="espec4-checkall-clearall">
                              <Button2
                                name="checkall"
                                text="Check All"
                                type="button"
                                classname="linkButton"
                                onClick={selectAllEngines}
                              />
                              &nbsp;/&nbsp;
                              <Button2
                                name="clearall"
                                text="Clear All"
                                type="button"
                                classname="linkButton"
                                onClick={clearAllEngines}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="espec4-main-grid">
              {/* Section for all engine options */}
              {gridview ? (
                <div className="espec4-grid-table-wrapper">
                  {isLoading ? (
                    <div className="loading-container">
                      <div className="loading-spinner"></div>
                      <div className="loading-text">Loading...</div>
                    </div>
                  ) : (
                    <div className="engine-table-container">
                      <div className="engine-table-scroll">
                        <table className="engine-table">
                          <thead className="engine-table-header">
                            <tr>
                              <th>Comp</th>
                              <th
                                onClick={() => handleSort("manufacturer")}
                                className="sortable-header"
                              >
                                Manufacturer / Model{" "}
                                {getSortIcon("manufacturer")}
                              </th>
                              <th
                                onClick={() => handleSort("engine_application")}
                                className="sortable-header"
                              >
                                Engine
                                <br />
                                Application {getSortIcon("engine_application")}
                              </th>
                              <th
                                onClick={() => handleSort("power_output_hp")}
                                className="sortable-header"
                              >
                                Max Power
                                <br />
                                Output
                                <br />
                                (hp) {getSortIcon("power_output_hp")}
                              </th>
                              <th
                                onClick={() => handleSort("torque_lbft")}
                                className="sortable-header"
                              >
                                Max Torque
                                <br />
                                (lb-ft) {getSortIcon("torque_lbft")}
                              </th>
                              <th
                                onClick={() => handleSort("ignition_type")}
                                className="sortable-header"
                              >
                                Ignition
                                <br />
                                Type
                                {getSortIcon("ignition_type")}
                              </th>
                              <th
                                onClick={() => handleSort("displacement_l")}
                                className="sortable-header"
                              >
                                Displacement
                                <br />
                                (L) {getSortIcon("displacement_l")}
                              </th>
                              <th
                                onClick={() => handleSort("dry_weight_lb")}
                                className="sortable-header"
                              >
                                Dry Weight
                                <br />
                                (lb) {getSortIcon("dry_weight_lb")}
                              </th>
                              <th
                                onClick={() =>
                                  handleSort("cylinder_configuration")
                                }
                                className="sortable-header"
                              >
                                Cylinder
                                <br />
                                Layout
                                {getSortIcon("cylinder_configuration")}
                              </th>
                              <th
                                onClick={() => handleSort("compression_ratio")}
                                className="sortable-header"
                              >
                                Compression
                                <br />
                                Ratio {getSortIcon("compression_ratio")}
                              </th>

                              <th
                                onClick={() =>
                                  handleSort("brake_thermal_efficiency")
                                }
                                className="sortable-header"
                              >
                                Brake
                                <br />
                                Thermal Effic
                                {getSortIcon("brake_thermal_efficiency")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {getSortedEngines().map((engine, index) => (
                              <tr
                                key={`${engine.manufacturer}-${engine.model}-${index}`}
                                className="engine-table-row"
                              >
                                <td>
                                  <input
                                    type="checkbox"
                                    className="espec4-engine-checkbox"
                                    checked={selectedEngineIds.includes(
                                      engine.id,
                                    )}
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={() => toggleEngine(engine.id)}
                                  />
                                </td>

                                <td>
                                  {engine.manufacturer}
                                  {engine.manufacturer?.toLowerCase() ===
                                    "elf-tech" && <sup>TM</sup>}{" "}
                                  {engine.model}
                                </td>
                                <td>{engine.engine_application}</td>
                                <td>{engine.power_output_hp}</td>
                                <td>{engine.torque_lbft}</td>
                                <td>{engine.ignition_type}</td>
                                <td>{engine.displacement_l}</td>
                                <td>{engine.dry_weight_lb}</td>
                                <td>{engine.cylinder_configuration}</td>
                                <td>{engine.compression_ratio}</td>

                                <td>
                                  {formatPercentage(
                                    engine.brake_thermal_efficiency,
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="espec4-columns-wrapper">
                  {isLoading ? (
                    <div className="espec4-loading-container">
                      <div className="espec4-loading-spinner"></div>
                      <div className="espec4-loading-text">Loading...</div>
                    </div>
                  ) : (
                    <>
                      {noData && (
                        <div className="espec4-no-data-container">
                          <div className="espec4-no-data-message">
                            No results match your search criteria.
                          </div>
                        </div>
                      )}
                      <div className="espec4-card-list">
                        {engines.map((engine, index) => {
                          const prevEngine = engines[index - 1];

                          return (
                            <div key={index}>
                              <div
                                className={`espec4-engine-card ${
                                  engine.manufacturer?.toLowerCase() ===
                                  "elf-tech"
                                    ? "engine-card-elf"
                                    : "engine-card-gray"
                                }`}
                                onClick={() => toggleEngine(engine.id)}
                              >
                                <div>
                                  <div className="espec4-engine-header">
                                    <div
                                      className={`espec4-engine-title ${
                                        engine.manufacturer?.toLowerCase() ===
                                        "elf-tech"
                                          ? "title-elf-tech"
                                          : "title-engine"
                                      }`}
                                    >
                                      {engine.manufacturer}
                                      {engine.manufacturer?.toLowerCase() ===
                                        "elf-tech" && <sup>TM</sup>}{" "}
                                      {engine.model}
                                    </div>
                                    <input
                                      type="checkbox"
                                      className="espec4-engine-checkbox"
                                      checked={selectedEngineIds.includes(
                                        engine.id,
                                      )}
                                      onClick={(e) => e.stopPropagation()}
                                      onChange={() => toggleEngine(engine.id)}
                                    />
                                  </div>

                                  <div className="espec4-engine-grid">
                                    <div className="espec4-item">
                                      <span className="label">Application</span>
                                      <span>{engine.engine_application}</span>
                                    </div>

                                    <div className="espec4-item">
                                      <span className="label">
                                        Max Power Output (hp)
                                      </span>
                                      <span>{engine.power_output_hp}</span>
                                    </div>

                                    <div className="espec4-item">
                                      <span className="label">
                                        Max Torque (lb-ft)
                                      </span>
                                      <span>{engine.torque_lbft}</span>
                                    </div>

                                    <div className="espec4-item">
                                      <span className="label">
                                        Ignition Type
                                      </span>
                                      <span className="engine4-data">
                                        {engine.ignition_type}
                                      </span>
                                    </div>

                                    <div className="espec4-item">
                                      <span className="label">
                                        Displacement (L)
                                      </span>
                                      <span>{engine.displacement_l}</span>
                                    </div>
                                    <div className="espec4-item">
                                      <span className="label">
                                        Dry Weight (lb)
                                      </span>
                                      <span>{engine.dry_weight_lb}</span>
                                    </div>

                                    <div className="espec4-item">
                                      <span className="label">
                                        Cylinder Layout
                                      </span>
                                      <span>
                                        {engine.cylinder_configuration}
                                      </span>
                                    </div>

                                    <div className="espec4-item">
                                      <span className="label">
                                        Compression Ratio
                                      </span>
                                      <span>{engine.compression_ratio}</span>
                                    </div>

                                    <div className="espec4-item">
                                      <span className="label">
                                        Brake Thermal Efficiency
                                      </span>
                                      <span>
                                        {formatPercentage(
                                          engine.brake_thermal_efficiency,
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
